import React, { useEffect, useState } from 'react';
import CustomInput from '../../components/form/CustomInput';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from "yup";
import { useFormik } from "formik";
import { resetConfirm, validaToken, } from '../../helpers/configRoutes/backend_helper'
import CustomButton from '../../components/form/CustomButton';
import CustomCodeInput from '../../components/form/CustomCodeInput';
import CustomButtonConfirm from '../../components/form/CustomButtonConfirm';

const AsignPassword = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const { token } = useParams()

    const validation = useFormik({
        initialValues: {
            email: '',
            password: '',
            passwordConfirm: '',
            tokenSms: '',
            token: token
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email("Correo electrónico no válido")
                .required("Ingresa tu correo electrónico"),
            password: Yup.string()
                .required("Ingresa tu contraseña")
                .min(8, "La contraseña debe tener al menos 8 caracteres")
                .matches(/[A-Z]/, "La contraseña debe contener al menos una letra mayúscula")
                .matches(/[a-z]/, "La contraseña debe contener al menos una letra minúscula")
                .matches(/[0-9]/, "La contraseña debe contener al menos un número"),
            passwordConfirm: Yup.string()
                .oneOf([Yup.ref('password'), null], "Las contraseñas no coinciden")
                .required("Confirma tu contraseña")
        }),
        onSubmit: async (values, { setErrors }) => {
            setLoading(true)
            const response = await resetConfirm(values);
            if (response.status === true) {
                navigate('/login');
            } else {
                if (response.errors?.length) {
                    setErrors(response.errors);
                }
            }
            setLoading(false)
        }
    });

    useEffect(() => {
        const getValidaToken = async () => {
            const response = await validaToken(validation.values)
            if (response.status) {
                validation.setFieldValue('email', response.email)
            }
        };
        getValidaToken();
    }, []);


    return (
        <div className="min-h-screen w-full bg-cs-bg flex flex-col justify-center px-5">

            <div className="bg-cs-surface rounded-2xl p-6 shadow-soft animate-fadeIn">

                <h1 className="text-lg font-semibold text-cs-dark mb-1">
                    Nueva contraseña
                </h1>

                <p className="text-sm text-cs-muted mb-6">
                    Crea tu nueva contraseña para continuar
                </p>

                <form
                    className="flex flex-col gap-4"
                    onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                    }}
                >
                    <CustomInput
                        placeholder="Nueva contraseña"
                        type="password"
                        name="password"
                        error={validation.errors.password}
                        value={validation.values.password}
                        handleChange={validation.handleChange}
                    />

                    <CustomInput
                        placeholder="Confirmar contraseña"
                        type="password"
                        name="passwordConfirm"
                        error={validation.errors.passwordConfirm}
                        value={validation.values.passwordConfirm}
                        handleChange={validation.handleChange}
                    />

                    <div>
                        <p className="text-sm text-cs-muted mb-2">
                            Código de verificación
                        </p>

                        <CustomCodeInput
                            length={6}
                            validation={validation}
                            name="tokenSms"
                            value={validation.values.tokenSms}
                            onChange={validation.handleChange}
                        />
                    </div>

                    <CustomButtonConfirm
                        loading={loading}
                        textLoad="Guardando"
                        text="Guardar contraseña"
                        className="mt-2"
                    />
                </form>
            </div>

            <button
                type="button"
                onClick={() => navigate('/login')}
                className="mt-6 text-center text-sm text-cs-muted"
            >
                Volver al inicio de sesión
            </button>

        </div>
    );
}

export default AsignPassword;
